// All projects, newest/featured first. No images — text-only cards.
// To add a project: copy an entry, edit, done. `demoLink` shows a green
// "Live" indicator; `githubLink` shows a "Code" link. Both are optional.

export const projects = [
  {
    title: "RAG Document Chat",
    description:
      "Hand-built Retrieval-Augmented Generation app that chats with your own PDFs and DOCX files, with cited answers",
    techStack: "Next.js, TypeScript, Tailwind, PostgreSQL (pgvector), Gemini LLM & Embeddings, Vercel Blob",
    demoLink: "https://rag-document-chat-application.vercel.app/",
    githubLink: "https://github.com/MadhuVarshaP/RAG-document-chat-app",
  },
  {
    title: "BPMS",
    description:
      "Blockchain-Based Patch Management System using IPFS and on-chain hash verification for tamper-proof software patches",
    techStack: "Solidity, Next.js, Express, MongoDB, Wagmi, Base",
    demoLink: "https://bpms-frontend.vercel.app/",
    githubLink:
      "https://github.com/MadhuVarshaP/blockchain-patch-management-system",
  },
  {
    title: "Streams in Somnia",
    description:
      "NFT marketplace with real-time royalty streaming and flexible multi-recipient splits",
    techStack: "Next.js, TypeScript, Solidity, Wagmi, IPFS, Somnia",
    demoLink: "https://streams-in-somnia.vercel.app/",
    githubLink: "https://github.com/MadhuVarshaP/StreamsinSomnia",
  },
  {
    title: "MorphGift",
    description: "Decentralized USDT Gift Voucher Platform",
    techStack: "Solidity, TypeScript, Ethers.js, Morph Holesky",
    demoLink: "https://morph-gift.vercel.app/",
    githubLink: "https://github.com/MadhuVarshaP/MorphGift",
  },
];
